/**
 * Monotonic seed source for exercise realization.
 *
 * Exercise generators take a seed. Seeding with `Date.now()` coupled generation
 * to the wall clock — two rounds built in the same millisecond collided, and
 * `meta.seed` was never reproducible. A process-global counter with a random
 * base gives each round a distinct seed, still varies across page loads
 * (sessions), and keeps generation off the clock.
 *
 * Deliberately NOT persisted: variety across sessions is the goal. Item
 * *ordering* within a session is seeded separately (see the scheduler's
 * `buildSession` seed).
 */
let counter = Math.floor(Math.random() * 0x7fffffff);

/** Return the next unique realization seed (positive 31-bit int). */
export function nextRoundSeed(): number {
  counter = (counter + 1) & 0x7fffffff;
  return counter;
}
